export enum StatisticsAggregateInterval {
  ONE_HOUR = '1h',
  ONE_DAY = '1d'
}

export default StatisticsAggregateInterval
